var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserAgentApplication } from 'msal';
import { TelemetryEvents } from '@employee-experience/common/lib/TelemetryEvents';
export class MSALClient {
    constructor(options, telemetryClient) {
        this.config = options;
        this.authContext = new UserAgentApplication(Object.assign(Object.assign({}, options), { cache: Object.assign({ cacheLocation: 'sessionStorage', storeAuthStateInCookie: this.isIE() }, options.cache), auth: options.auth }));
        this.telemetryClient = telemetryClient;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.authContext.handleRedirectCallback(() => { });
    }
    login(loginOptions = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.telemetryClient.trackTrace({
                    message: TelemetryEvents.UserLogInRequested,
                });
                try {
                    this.authContext.loginRedirect({
                        scopes: loginOptions === null || loginOptions === void 0 ? void 0 : loginOptions.scopes,
                    });
                    resolve();
                }
                catch (ex) {
                    this.telemetryClient.trackTrace({
                        message: TelemetryEvents.UserLoginFailed,
                    });
                    reject(ex);
                }
            });
        });
    }
    logOut() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.telemetryClient.trackTrace({
                    message: TelemetryEvents.UserLogOutRequested,
                });
                try {
                    this.authContext.logout();
                    resolve();
                }
                catch (ex) {
                    this.telemetryClient.trackTrace({
                        message: TelemetryEvents.UserLogOutFailed,
                    });
                    reject(ex);
                }
            });
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    const user = this.authContext.getAccount();
                    if (!user)
                        return resolve(null);
                    resolve({
                        id: user.userName,
                        email: user.userName,
                        name: user.name,
                        oid: user.accountIdentifier,
                    });
                }
                catch (ex) {
                    reject(ex);
                }
            });
        });
    }
    getUserId() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const user = yield this.getUser();
                    resolve(user ? user.id : null);
                }
                catch (ex) {
                    reject(ex);
                }
            }));
        });
    }
    isLoggedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    resolve((yield this.getUser()) !== null);
                }
                catch (ex) {
                    reject(ex);
                }
            }));
        });
    }
    acquireToken(scopes) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a, _b;
                let normalizedScopes = [];
                if (typeof scopes === 'string')
                    normalizedScopes.push(scopes + '/.default');
                else
                    normalizedScopes = [...scopes];
                this.authContext
                    .acquireTokenSilent({
                    scopes: normalizedScopes,
                    authority: (_a = this.config.auth) === null || _a === void 0 ? void 0 : _a.authority,
                    redirectUri: ((_b = this.config.auth) === null || _b === void 0 ? void 0 : _b.redirectUri) ||
                        window.location.origin,
                })
                    .then((tokenResponse) => {
                    resolve(tokenResponse.accessToken);
                })
                    .catch(() => {
                    var _a, _b;
                    this.authContext.acquireTokenRedirect({
                        scopes: normalizedScopes,
                        authority: (_a = this.config.auth) === null || _a === void 0 ? void 0 : _a.authority,
                        redirectUri: ((_b = this.config.auth) === null || _b === void 0 ? void 0 : _b.redirectUri) ||
                            window.location.origin,
                    });
                });
            });
        });
    }
    isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ') > -1;
        const msie11 = ua.indexOf('Trident/') > -1;
        return msie || msie11;
    }
}
//# sourceMappingURL=MSALClient.js.map